import React from 'react';
import ConnectedFeedPage from './ConnectedFeedPage';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import { configureStore } from '@eb/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eb/site-analytics';

import { getInitialState } from '../redux/utils';
import reducer from '../redux/rootReducer';

export default class FeedPageWithStore extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialState(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    render() {
        return (
            <Provider store={this._store}>
                <ConnectedFeedPage {...this.props} />
            </Provider>
        );
    }
}
